import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Download, X } from "lucide-react";
import { useInstall } from "@/lib/pwaInstall";

export function InstallPrompt() {
  const { t } = useTranslation();
  const { canInstall, isIOS, hasNativePrompt, promptInstall } = useInstall();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("coccon_install_dismissed") === "1"
  );

  const visible = canInstall && !dismissed;

  const dismiss = () => {
    setDismissed(true);
    localStorage.setItem("coccon_install_dismissed", "1");
  };

  const install = async () => {
    await promptInstall();
    dismiss();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="install-prompt"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-[360px] z-[90] glass frame-pulse rounded-2xl p-4 flex items-center gap-4"
        >
          <span className="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center"
            style={{ background: "radial-gradient(circle at 35% 30%, hsl(40 96% 74%), hsl(28 85% 52%))" }}>
            <Download size={20} className="text-[hsl(22,60%,18%)]" />
          </span>
          <p className="flex-1 text-sm text-foreground/80 leading-snug">
            {isIOS && !hasNativePrompt ? t("install.ios") : t("install.text")}
          </p>
          {hasNativePrompt && (
            <button
              data-testid="install-accept-btn"
              onClick={install}
              className="btn-frost-orange text-sm font-semibold px-4 py-2 rounded-full flex-shrink-0"
            >
              {t("install.cta")}
            </button>
          )}
          <button
            data-testid="install-dismiss-btn"
            onClick={dismiss}
            className="flex-shrink-0 text-foreground/40 hover:text-foreground/70 transition-colors"
            aria-label={t("install.later")}
          >
            <X size={18} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
